// pages/rules/RulesFormContent.tsx
import { Col, Divider } from 'antd';
import { ruleOutputItem, ruleTypeItem } from 'pages/rules/collapseItem';
import FeelExpressionForm from 'pages/rules/feelExpressionForm';
import { RuleApplicability } from 'pages/rules/subComponents';
import PureNumberInput from 'components/number/pureNumberInput';
import constants from 'core/constants/Constants';

const RulesFormContent = ({
  t,
  type,
  form,
  fileType,
  defaultFileListObj,
  uploadType,
  selectedAdjustmentLevel,
  groupConfigFields,
  state,
  ruleGroupConfigurationStatus,
  showRuleApplicability,
  showFeelExpression,
  isClawbackDirect,
  isClawbackNotSelected,
  clawbackType,
}) => {
  if (ruleGroupConfigurationStatus === false) {
    return (
      <Col md={6}>
        <PureNumberInput
          label={t('rules.enterAmount')}
          name="enter_amount"
          required={true}
          message={t('rules.messages.enterAmount')}
          placeholder={t('rules.enterAmount')}
          disabled={type === 'Show'}
        />
      </Col>
    );
  }

  if (isClawbackDirect || isClawbackNotSelected) return null;

  return (
    <>
      {showRuleApplicability ? (
        <>
          <Divider className="border-gray-200 mt-0" />
          <RuleApplicability
            type={type}
            form={form}
            configFields={state.configFields}
            disabled={type === 'Show'}
            ruleApplicabilityError={state.ruleApplicabilityError}
            isSavedClick={state.isSavedClick}
          />
        </>
      ) : null}
      <Divider className="border-gray-200 mt-lg" />
      {ruleTypeItem(
        fileType,
        defaultFileListObj,
        uploadType,
        form,
        type,
        clawbackType
      )}

      {showFeelExpression ? (
        <>
          <div style={{ display: 'none' }}>
            <Divider className="border-gray-200" />
            {ruleOutputItem()}
          </div>
          <Divider className="border-gray-200" />
          <FeelExpressionForm
            type={type}
            disabled={type === 'Show'}
            form={form}
            forceShow={
              !!(
                clawbackType === constants.clawbackTypes.partial &&
                type !== 'Show'
              )
            }
            configFields={
              selectedAdjustmentLevel === constants.adjustmentLevels.group
                ? groupConfigFields
                : state.configFields
            }
          />
        </>
      ) : null}
    </>
  );
};

export default RulesFormContent;
